<template>
  <div id="skills-summary" class="overflow-x-auto mx-4 mb-5">
    <div v-if="isLoading" class="w-full flex justify-center items-center h-96">
      <pl-spinner/>
    </div>
    <div v-else>
      <div v-if="skills && skills.length !== 0">
        <table class="table-auto min-w-full">
          <thead>
            <tr>
              <th class="text-left px-2 py-2 border-b bg-white text-blueGray-800 select-none">Skill</th>
              <th v-for="(data, index) in skills" :key="index"  class="text-center px-3 py-2 border-b cursor-pointer hover:underline bg-white ">
                <Popper
                  :append-to-body="true"
                  :prevent-default="true"
                  trigger="hover"
                  :options="{
                    placement: 'top',
                  }"
                  @show="openPopper"
                  @hide="closePopper"
                >
                  <div class="popper bg-white rounded-md shadow-sm relative">
                    <div class="flex items-center space-x-2 px-3 py-2">
                      <div class="h-5 w-5 bg-blue rounded-full flex items-center justify-center">
                        <img src="/static/roundtable_icons/written_icon.svg" class="w-2.5 h-2.5"/>
                      </div>
                      <h6 class="text-blueGray-800 text-xs font-poppins">{{ data.roundtable }}</h6>
                    </div>
                  </div>
                  <button @click="handleGoRT(data.roundtable_id)" class="h-full items-center font-semibold hover:underline font-poppins text-blueGray-800" slot="reference">
                    RT {{ index + 1  }}
                  </button>
                </Popper>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dataName, rowIndex) in skillsName" :key="rowIndex">
              <td  class="border-b py-1.5 px-2 font-poppins font-light">
                <Popper 
                  :append-to-body="true"
                  :prevent-default="true"
                  trigger="clickToToggle"
                  :options="{
                    placement: 'right',
                    modifiers: { offset: { offset: '0,8px' } }
                  }"
                  @show="openPopper(dataName)"
                  @hide="closePopper"
                >
                  <div class="popper bg-white rounded-md shadow-sm relative w-64 pb-4" v-click-outside="closePopper">
                    <div class="py-2.5 font-semibold text-sm font-poppins text-left w-full px-3">
                      {{ dataName }}
                    </div>
                    <div class="text-left text-xs flex flex-col px-3 text-gray-700 font-poppins font-light">
                      <div class="html-content font-poppins font-light" v-html="handleSetAssessmentDescription(dataName)"></div>
                    </div>
                    <div v-if="selected_points_description && selected_points_description.length > 0" class="mt-4 px-3">
                      <div v-for="(point) in selected_points_description" class="flex flex-col text-left text-xs space-y-2">
                        <div class="flex items-center space-x-1 mb-2">
                          <div class=""><span class="font-semibold font-poppins text-gray-800">({{ point.value }}) Level: </span><span class="text-gray-700">{{ point.description }}</span></div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                  <button type="button" class="h-full items-center font-semibold hover:underline font-poppins mr-2 text-blueGray-800" slot="reference">
                    <i class="fa-solid fa-circle-info"></i>
                  </button>
                </Popper>
                <span>{{ dataName }}</span>
              </td>
              <td v-for="(data, index) in skills" :key="index" class="text-left px-3 py-2 border-b bg-white">
                <!-- {{ data }} -->
                <div v-for="(skill, index) in data.assessments"  :key="index">
                  <div class="flex justify-center items-center">
                    <div 
                      v-if="skill.title === dataName" 
                      class="w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded"
                      :class="{
                        'bg-blueDark bg-opacity-10': parseInt(skill.value) === 0,
                        'bg-blueDark bg-opacity-20': parseInt(skill.value) === 1,
                        'bg-blueDark bg-opacity-40': parseInt(skill.value) === 2,
                        'bg-blueDark bg-opacity-60': parseInt(skill.value) === 3,
                        'bg-blueDark bg-opacity-80': parseInt(skill.value) === 4,
                        'bg-blueDark ': parseInt(skill.value) > 4,
                      }"
                    >
                      <span>{{ skill.value }}</span>
                    </div>
                  </div>
                </div>
                <div class="flex justify-center items-center" v-if="!data.stats.skills.some(item => item.title === dataName)">
                  <div class="w-8 h-8 flex items-center text-white justify-center text-base select-none font-poppins font-semibold rounded bg-gray-200">
                    <span class="text-blueGray-500">-</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="w-full flex justify-center items-center h-96">
        <span class="font-poppins text-blueGray-800">No data to display</span>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import store from 'store';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import Tooltip from '../../../../../components/Tooltip.vue';
  import Popper from 'vue-popperjs';
  import { EventBus } from '../../../../../utils/event-bus';

  Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        // here I check that click was outside the el and his children
        if (!(el == event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    },
  });

  export default Vue.extend({
    data() {
      return {
        data: [],
        skills: null,
        skillsName: [],
        isLoading: false,
        selected_points_description: [],
      };
    },
    components: {
      Tooltip,
      Popper
    },
    watch: {
      '$route': async function () {
        this.skillsName = [];
        this.isLoading = true;
        const { courseID, studentID } = this.$route.params;
        const { startDate, endDate } = this.$route.query;
        const dateStart = startDate !== undefined ? moment.unix(startDate).format('YYYY/MM/DD') + ' ' + '00:00:00' : '';
        const dateEnd = endDate !== undefined ? moment.unix(endDate).format('YYYY/MM/DD') + ' ' + '23:59:59' : '';
        const result = await store.dispatch('setCourseStudentSkills', { courseID, studentID, skill: '', dateStart, dateEnd });
        this.skills = result.filter((r) => r.roundtable_id);
        const uniqueTags = new Set();
        this.skills.forEach(skill => {
          if (skill.assessments && Array.isArray(skill.assessments)) {
            skill.assessments.forEach(assessment => {
              if (!uniqueTags.has(assessment.tag)) {
                uniqueTags.add(assessment.tag);
                this.skillsName.push(assessment.title);
              }
            });
          }
        });

        this.skillsName.sort((a, b) => a.localeCompare(b));
        
        this.isLoading = false;
      },
    },
    computed: {
      ...mapGetters([
        'getStudentSummary',
        'getCourseDetail',
        'hasTeacherPermissionsInCourse',
        'getProfile',
      ]),
    },
    methods: {
      handleSetAssessmentDescription: function(assessmentTitle) {
        if (this.isLoading === false && this.getCourseDetail) {
          const assessment = this.getCourseDetail.points_settings.peer_rewards.filter((p) =>p.title === assessmentTitle);
          if (assessment.length > 0) {
            if (typeof assessment[0].description === 'object') {
              return assessment[0].description.join('. '); 
            } else {
              return assessment[0].description;
            }

          } else {
            return 'No description';
          }
          
        }
      },
      handleSetPointsDescription: function(assessmentTitle) {
        if (this.isLoading === false && this.getCourseDetail) {
          const assessment = this.getCourseDetail.points_settings.peer_rewards.filter((p) => p.title === assessmentTitle);
          return assessment.points_description;
        }
      },
      handleGoRT: function(roundtable_id) {
        if (this.getProfile.is_paid === false) {
          return;
        }
        EventBus.$emit('handleChangeReportsTab', 'course.student-reports.discussion', roundtable_id);
      },
      openPopper(dataName) {
        this.info_open = true;
        if (dataName) {
          const assessment = this.getCourseDetail.points_settings.peer_rewards.filter((p) => p.title === dataName);
          if (assessment) {
            this.selected_points_description = assessment[0].points_description;
          }
        }
      },
      closePopper() {
        this.info_open = false;
        
      },
      setScore(roundtable, skillTag) {
        return this.skills.map((data) => {
          if (data.roundtable_id === roundtable) {
            return data.stats.skills.map((s) => {
              if (s.tag === skillTag) {
                return s.score;
              } else {
                return '0';
              }
            });
          }
        });
      }
    },
    mounted: async function () {
      this.isLoading = true;

      if (this.getProfile.is_paid) {
        const { courseID, studentID } = this.$route.params;
        const { startDate, endDate } = this.$route.query;
        const dateStart = startDate !== undefined ? moment.unix(startDate).format('YYYY/MM/DD') + ' ' + '00:00:00' : '';
        const dateEnd = endDate !== undefined ? moment.unix(endDate).format('YYYY/MM/DD') + ' ' + '23:59:59' : '';
        const result = await store.dispatch('setCourseStudentSkills', { courseID, studentID, skill: '', dateStart, dateEnd });

        this.skills = result.filter((r) => r.roundtable_id);
        const uniqueTags = new Set();
        this.skillsName = [];

        this.skills.forEach(skill => {
          if (skill.assessments && Array.isArray(skill.assessments)) {
            skill.assessments.forEach(assessment => {
              if (!uniqueTags.has(assessment.tag)) {
                  uniqueTags.add(assessment.tag);
                  this.skillsName.push(assessment.title);
              }
            });
          }
        });

        this.skillsName.sort((a, b) => a.localeCompare(b));

        console.log(JSON.stringify(this.skills));
        console.log(JSON.stringify(this.skillsName));

        this.isLoading = false;
        return;
      }

      if (this.getProfile.is_paid === false) {
        this.skills = [
        {
            roundtable: 'Sample Written RoundTable',
            roundtable_id: '0',
            published_date: '2025-04-21T14:59:58.719Z',
            assessments: [
              { tag: 'all_new_insight', title: 'New Insight', value: '3' },
              { tag: 'all_connects_ideas', title: 'Connects Ideas', value: '3' },
              { tag: 'all_challenges_ideas', title: 'Challenges Ideas', value: '3' },
              { tag: 'all_thoughtful_question', title: 'Thoughtful Question', value: '3'},
              { tag: 'all_uses_evidence', title: 'Uses Evidence', value: '3' },
            ],
            total_class_assessment: 15,
            roundtable_points: {
              peer_rewards: [
                {
                  tag: 'all_new_insight',
                  icon: 'point_types/well_written.svg',
                  title: 'New Insight',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ["Introduces new ideas, arguments, perspectives, or analysis that hadn't been considered in the RoundTable thus far."],
                  points_description: [],
                },
                {
                  tag: 'all_connects_ideas',
                  icon: 'point_types/well_written.svg',
                  title: 'Connects Ideas',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ['Deliberately builds on, connects, or extends one or more ideas from the RoundTable or associated materials.',],
                  points_description: [],
                },
                {
                  tag: 'all_challenges_ideas',
                  icon: 'point_types/well_written.svg',
                  title: 'Challenges Ideas',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ["Disagrees or challenges other students' ideas or arguments in a way that is both respectful and charitable to their classmate(s)."],
                  points_description: [],
                },
                {
                  tag: 'all_thoughtful_question',
                  icon: 'point_types/well_written.svg',
                  title: 'Thoughtful Question',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ['Asks a question that probes on an existing line of inquiry, opens up the conversation to a new perspective/frame, or moves the discussion forward.'],
                  points_description: [],
                },
                {
                  tag: 'all_uses_evidence',
                  icon: 'point_types/well_written.svg',
                  title: 'Uses Evidence',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ['Supports an argument or perspective with evidence from the text, resources, or independent research.'],
                  points_description: [],
                },
              ],
            },
            average_class: 0,
            type: 'roundtable',
            stats: {
              skills: [
                {
                  tag: 'all_new_insight',
                  title: 'New Insight',
                  score: 20,
                  avg: 3.3333333333333335,
                  count: 6,
                },
                {
                  tag: 'all_connects_ideas',
                  title: 'Connects Ideas',
                  score: 20,
                  avg: 3.3333333333333335,
                  count: 6,
                },
                {
                  tag: 'all_challenges_ideas',
                  title: 'Challenges Ideas',
                  score: 13,
                  avg: 2.1666666666666665,
                  count: 6,
                },
                {
                  tag: 'all_thoughtful_question',
                  title: 'Thoughtful Question',
                  score: 26,
                  avg: 4.333333333333333,
                  count: 6,
                },
                {
                  tag: 'all_uses_evidence',
                  title: 'Uses Evidence',
                  score: 18,
                  avg: 3,
                  count: 6,
                },
              ],
              class_score: 0,
              class_avg: 16.166666666666668,
            },
          },
          {
            roundtable: 'The Escalating US-China Trade War: Tariff Clash Intensifies Global Tensions',
            roundtable_id: '1',
            published_date: '2025-04-21T14:59:58.719Z',
            assessments: [
              { tag: 'all_new_insight', title: 'New Insight', value: '5' },
              { tag: 'all_connects_ideas', title: 'Connects Ideas', value: '3' },
              { tag: 'all_challenges_ideas', title: 'Challenges Ideas', value: '2' },
              { tag: 'all_thoughtful_question', title: 'Thoughtful Question', value: '6'},
              { tag: 'all_uses_evidence', title: 'Uses Evidence', value: '5' },
            ],
            total_class_assessment: 21,
            roundtable_points: {
              peer_rewards: [
                {
                  tag: 'all_new_insight',
                  icon: 'point_types/well_written.svg',
                  title: 'New Insight',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ["Introduces new ideas, arguments, perspectives, or analysis that hadn't been considered in the RoundTable thus far."],
                  points_description: [],
                },
                {
                  tag: 'all_connects_ideas',
                  icon: 'point_types/well_written.svg',
                  title: 'Connects Ideas',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ['Deliberately builds on, connects, or extends one or more ideas from the RoundTable or associated materials.',],
                  points_description: [],
                },
                {
                  tag: 'all_challenges_ideas',
                  icon: 'point_types/well_written.svg',
                  title: 'Challenges Ideas',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ["Disagrees or challenges other students' ideas or arguments in a way that is both respectful and charitable to their classmate(s)."],
                  points_description: [],
                },
                {
                  tag: 'all_thoughtful_question',
                  icon: 'point_types/well_written.svg',
                  title: 'Thoughtful Question',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ['Asks a question that probes on an existing line of inquiry, opens up the conversation to a new perspective/frame, or moves the discussion forward.'],
                  points_description: [],
                },
                {
                  tag: 'all_uses_evidence',
                  icon: 'point_types/well_written.svg',
                  title: 'Uses Evidence',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ['Supports an argument or perspective with evidence from the text, resources, or independent research.'],
                  points_description: [],
                },
              ],
            },
            average_class: 0,
            type: 'roundtable',
            stats: {
              skills: [
                {
                  tag: 'all_new_insight',
                  title: 'New Insight',
                  score: 20,
                  avg: 3.3333333333333335,
                  count: 6,
                },
                {
                  tag: 'all_connects_ideas',
                  title: 'Connects Ideas',
                  score: 20,
                  avg: 3.3333333333333335,
                  count: 6,
                },
                {
                  tag: 'all_challenges_ideas',
                  title: 'Challenges Ideas',
                  score: 13,
                  avg: 2.1666666666666665,
                  count: 6,
                },
                {
                  tag: 'all_thoughtful_question',
                  title: 'Thoughtful Question',
                  score: 26,
                  avg: 4.333333333333333,
                  count: 6,
                },
                {
                  tag: 'all_uses_evidence',
                  title: 'Uses Evidence',
                  score: 18,
                  avg: 3,
                  count: 6,
                },
              ],
              class_score: 0,
              class_avg: 16.166666666666668,
            },
          },
          {
            roundtable: 'Trump Clarifies Trade Stance: No Tariff Exemptions for Electronics Imports',
            roundtable_id: '2',
            published_date: '2025-04-21T14:59:58.719Z',
            assessments: [
              { tag: 'all_new_insight', title: 'New Insight', value: '2' },
              { tag: 'all_connects_ideas', title: 'Connects Ideas', value: '5' },
              { tag: 'all_challenges_ideas', title: 'Challenges Ideas', value: '4' },
              { tag: 'all_thoughtful_question', title: 'Thoughtful Question', value: '3'},
              { tag: 'all_uses_evidence', title: 'Uses Evidence', value: '1' },
            ],
            total_class_assessment: 15,
            roundtable_points: {
              peer_rewards: [
                {
                  tag: 'all_new_insight',
                  icon: 'point_types/well_written.svg',
                  title: 'New Insight',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ["Introduces new ideas, arguments, perspectives, or analysis that hadn't been considered in the RoundTable thus far."],
                  points_description: [],
                },
                {
                  tag: 'all_connects_ideas',
                  icon: 'point_types/well_written.svg',
                  title: 'Connects Ideas',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ['Deliberately builds on, connects, or extends one or more ideas from the RoundTable or associated materials.',],
                  points_description: [],
                },
                {
                  tag: 'all_challenges_ideas',
                  icon: 'point_types/well_written.svg',
                  title: 'Challenges Ideas',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ["Disagrees or challenges other students' ideas or arguments in a way that is both respectful and charitable to their classmate(s)."],
                  points_description: [],
                },
                {
                  tag: 'all_thoughtful_question',
                  icon: 'point_types/well_written.svg',
                  title: 'Thoughtful Question',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ['Asks a question that probes on an existing line of inquiry, opens up the conversation to a new perspective/frame, or moves the discussion forward.'],
                  points_description: [],
                },
                {
                  tag: 'all_uses_evidence',
                  icon: 'point_types/well_written.svg',
                  title: 'Uses Evidence',
                  amount: 1,
                  default: true,
                  category: 'impression',
                  description: ['Supports an argument or perspective with evidence from the text, resources, or independent research.'],
                  points_description: [],
                },
              ],
            },
            average_class: 0,
            type: 'roundtable',
            stats: {
              skills: [
                {
                  tag: 'all_new_insight',
                  title: 'New Insight',
                  score: 20,
                  avg: 3.3333333333333335,
                  count: 6,
                },
                {
                  tag: 'all_connects_ideas',
                  title: 'Connects Ideas',
                  score: 20,
                  avg: 3.3333333333333335,
                  count: 6,
                },
                {
                  tag: 'all_challenges_ideas',
                  title: 'Challenges Ideas',
                  score: 13,
                  avg: 2.1666666666666665,
                  count: 6,
                },
                {
                  tag: 'all_thoughtful_question',
                  title: 'Thoughtful Question',
                  score: 26,
                  avg: 4.333333333333333,
                  count: 6,
                },
                {
                  tag: 'all_uses_evidence',
                  title: 'Uses Evidence',
                  score: 18,
                  avg: 3,
                  count: 6,
                },
              ],
              class_score: 0,
              class_avg: 16.166666666666668,
            },
          },
        ];
      }

      

      const uniqueTags = new Set();
      this.skillsName = [];
      this.skills.forEach(skill => {
        if (skill.assessments && Array.isArray(skill.assessments)) {
          skill.assessments.forEach(assessment => {
            if (!uniqueTags.has(assessment.tag)) {
              uniqueTags.add(assessment.tag);
              this.skillsName.push(assessment.title);
            }
          });
        }
      });

      this.skillsName.sort((a, b) => a.localeCompare(b));

      this.isLoading = false;
      
    },
  });
</script>



// WEBPACK FOOTER //
// SkillsSummary.vue?ed4d930c